module.exports = __webpack_public_path__ + "static/media/gallery13.bb5c7728.png";